import React from 'react';
import ReactDOM from 'react-dom';

const render = (Component, mountOnNodeId) => {
  ReactDOM.render(
      <Component />,
    document.getElementById(mountOnNodeId),
  );
};

export default render;



// WEBPACK FOOTER //
// ./src/common/utils/renderToDOM.js